import React, { useCallback, useMemo } from 'react';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import { SmallIcon, VerticalIcon, HorizontalIcon, BigIcon } from './icons';

import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';

const useStyles = createUseStyles(styles);

const ICONS = {
    small: <SmallIcon />,
    vertical: <VerticalIcon />,
    horizontal: <HorizontalIcon />,
    big: <BigIcon />,
};

function Size({ column, row, value, onChange, ...props }) {
    const classes = useStyles();
    const { t } = useWeb5Context();

    const onClick = useCallback(
        () => onChange && onChange({ columns: column, rows: row }),
        [column, onChange, row],
    );

    const size = useMemo(() => {
        if (column !== 3 && row === 1) return 'small';
        if (column === 3 && row === 1) return 'horizontal';
        if (column !== 3 && row === 2) return 'vertical';
        if (column === 3 && row === 2) return 'big';
    }, [column, row]);

    const selected = useMemo(
        () =>
            row === value?.rows &&
            (column === value?.columns || (column === 2 && value?.columns === 1)),
        [column, row, value?.columns, value?.rows],
    );

    const classNames = classnames(classes.size, `widgets-form__size--${size}`, {
        [classes.selected]: selected,
    });

    return (
        <div className={classNames} onClick={onClick} {...props}>
            <div className={classes.icon}>{ICONS[size]}</div>
            <Text type="caption" className={classes.text}>
                {t(`cfm_label_${size}`)}
            </Text>
        </div>
    );
}

export default Size;
